import apiClient from './client';

export const newsletterApi = {
  /**
   * Signs an address up to OnTheWeb's own newsletter. Public — no account needed,
   * and rate limited per IP on the server. Subscribing twice is a success, so a
   * resolved promise means "you're on the list", not "you were just added".
   */
  subscribe: async (email: string): Promise<void> => {
    await apiClient.post('/user/newsletter/subscribe', { email });
  },

  /**
   * Takes the address off the list. `found` is false for a link the server does
   * not recognise, which is a different thing from a failed request.
   */
  unsubscribe: async (token: string): Promise<{ found: boolean; email?: string }> => {
    const response = await apiClient.post(`/user/newsletter/unsubscribe/${token}`);
    return response.data.data;
  },
};

export default newsletterApi;
